export const XDP_PAGE_GRID_CONTAINER_CLASS_NAME = 'xdp-page-grid-container';
export const XDP_KEY_INFORMATION_SLOT_CLASS_NAME = 'xdp-key-information-slot';
